import { SessionData } from "@/handlers/session";
import { createContext } from "react";

export type IAuthContext = {
  data: SessionData | null;
  refetch: () => Promise<void>;
} | null;

export const AuthContext = createContext<IAuthContext>(null);
